import { defineMessages } from 'react-intl'

export default defineMessages({
    bookingAccepted: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.bookingAccepted',
        defaultMessage: 'Accepted',
    },
    bookingRejected: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.bookingRejected',
        defaultMessage: 'Rejected',
    },
    bookingPending: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.bookingPending',
        defaultMessage: 'Pending',
    },
    bookingNumber: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.bookingNumber',
        defaultMessage: 'Booking number',
    },
    title: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.title',
        defaultMessage: 'Booking for {name}',
    },
    requestedBy: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.requestedBy',
        defaultMessage: 'Requested by',
    },
    startDate: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.startDate',
        defaultMessage: 'Start',
    },
    endDate: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.endDate',
        defaultMessage: 'End',
    },
    dealId: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.dealId',
        defaultMessage: 'Deal ID',
    },
    status: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.status',
        defaultMessage: 'Status',
    },
    bookingMessage: {
        id: 'components.AvailabilityDataTable.components.BookingInfoModal.bookingMessage',
        defaultMessage: 'Booking Message',
    },
})
